(function initializeRecentlyViewedScript() {
  if (window.__onlyfindzRecentlyViewedLoaded) return;
  window.__onlyfindzRecentlyViewedLoaded = true;

  const RECENTLY_VIEWED_KEY = 'recently_viewed_products';
  const cartIconMarkup = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" fill-rule="evenodd" class="icon icon-cart"><path d="M10 1.5a4 4 0 0 0-4 4H4a1 1 0 0 0-1 1l.75 10.5A1.5 1.5 0 0 0 5.25 18.5h9.5a1.5 1.5 0 0 0 1.5-1.5L17 6.5a1 1 0 0 0-1-1h-2a4 4 0 0 0-4-4zm3 4a3 3 0 0 0-6 0h6z"/></svg>';
  const wishlistLabel = 'Zur Merkliste hinzufügen';

  function recentlyViewedConsentGranted() {
    const consent = window.OnlyFindzConsent && typeof window.OnlyFindzConsent.get === 'function'
      ? window.OnlyFindzConsent.get()
      : null;

    return Boolean(consent && consent.preferences);
  }

  function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>"']/g, (char) => (
      { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]
    ));
  }

  function normalizeImageUrl(value) {
    if (!value) return '';
    try {
      const normalized = new URL(value, window.location.origin);
      if (normalized.hostname.includes('cdn.shopify.com')) {
        normalized.protocol = 'https:';
      }
      return normalized.toString();
    } catch (error) {
      console.error(error);
      return String(value);
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define(
      'recently-viewed-products',
      class RecentlyViewedProducts extends HTMLElement {
        connectedCallback() {
          try {
            this.limit = Number(this.dataset.limit || 6);
            this.currencyCode = this.dataset.currencyCode || 'EUR';
            this.cardStyle = this.dataset.cardStyle || 'standard';
            this.cardColorScheme = this.dataset.cardColorScheme || 'scheme-2';
            this.content = this.querySelector('[data-recently-viewed-content]');
            this.list = this.querySelector('[data-recently-viewed-list]');

            let current;
            try {
              current = JSON.parse(this.dataset.current || '{}');
            } catch (error) {
              console.error(error);
              return;
            }

            if (!current.handle) return;
            this.current = current;

            if (recentlyViewedConsentGranted()) {
              this.initializeWithConsent();
            } else {
              this.content?.setAttribute('hidden', '');
              this.waitForConsent();
            }
          } catch (error) {
            console.error(error);
          }
        }

        waitForConsent() {
          if (this.consentListenerAttached) return;
          this.consentListenerAttached = true;

          this.handleConsentChanged = () => {
            if (!recentlyViewedConsentGranted()) {
              try {
                window.localStorage.removeItem(RECENTLY_VIEWED_KEY);
              } catch (error) {
                console.error(error);
              }
              this.content?.setAttribute('hidden', '');
              return;
            }

            this.initializeWithConsent();
          };

          window.addEventListener('onlyfindz:consent-updated', this.handleConsentChanged);
        }

        initializeWithConsent() {
          if (!this.current || !recentlyViewedConsentGranted()) return;
          this.saveCurrentProduct(this.current);
          this.render(this.current.handle);
        }

        loadProducts() {
          try {
            const parsed = JSON.parse(window.localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]');
            return Array.isArray(parsed) ? parsed : [];
          } catch (error) {
            console.error(error);
            return [];
          }
        }

        saveCurrentProduct(current) {
          if (!recentlyViewedConsentGranted()) return;

          const products = this.loadProducts().filter((entry) => entry.handle !== current.handle);
          products.unshift(current);
          window.localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(products.slice(0, this.limit + 1)));
        }

        formatMoney(cents) {
          if (typeof cents !== 'number') return '';
          return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
            style: 'currency',
            currency: this.currencyCode,
          }).format(cents / 100);
        }

        buildPriceHtml(entry) {
          const onSale = typeof entry.compareAtPrice === 'number' && entry.compareAtPrice > entry.price;
          if (onSale) {
            return `
              <span class="onlyfindz-home__price">${this.formatMoney(entry.price)}</span>
              <span class="onlyfindz-home__compare">${this.formatMoney(entry.compareAtPrice)}</span>
            `;
          }
          return `<span class="onlyfindz-home__price">${this.formatMoney(entry.price)}</span>`;
        }

        buildActionsHtml(entry) {
          const availabilityHtml = entry.available !== false
            ? '<span class="onlyfindz-home__availability">Auf Lager</span>'
            : '<span class="onlyfindz-home__availability onlyfindz-home__availability--soldout">Nicht verfügbar</span>';
          const addToCartHtml = entry.available !== false && entry.variantId
            ? `
              <product-form>
                <form class="onlyfindz-home__quick-form" action="/cart/add" method="post" enctype="multipart/form-data">
                  <input type="hidden" name="id" value="${escapeHtml(entry.variantId)}">
                  <button type="submit" class="onlyfindz-home__icon-button" aria-label="${escapeHtml(entry.title)} in den Warenkorb">
                    ${cartIconMarkup}
                  </button>
                </form>
              </product-form>
            `
            : '';
          return `
            ${availabilityHtml}
            <div class="onlyfindz-home__card-actions">
              <a href="${escapeHtml(entry.url)}" class="onlyfindz-home__details-link">Details</a>
              ${addToCartHtml}
            </div>
          `;
        }

        async resolveProductEntry(entry) {
          if (!entry || !entry.handle) return entry;

          try {
            const response = await fetch(`/products/${encodeURIComponent(entry.handle)}.js`, {
              headers: {
                Accept: 'application/json',
              },
            });

            if (!response.ok) return {
              ...entry,
              image: normalizeImageUrl(entry.image),
            };

            const product = await response.json();
            const featuredImage = product.featured_image || (Array.isArray(product.images) ? product.images[0] : '');
            const firstVariant = Array.isArray(product.variants) ? product.variants[0] : null;

            return {
              ...entry,
              handle: product.handle || entry.handle,
              title: product.title || entry.title,
              vendor: product.vendor || entry.vendor,
              url: `/products/${product.handle || entry.handle}`,
              image: normalizeImageUrl(featuredImage || entry.image),
              imageAlt: product.title || entry.imageAlt || entry.title,
              price: typeof product.price === 'number' ? product.price : entry.price,
              compareAtPrice: typeof product.compare_at_price === 'number' ? product.compare_at_price : entry.compareAtPrice,
              available: typeof product.available === 'boolean' ? product.available : entry.available,
              variantId: firstVariant ? firstVariant.id : entry.variantId,
            };
          } catch (error) {
            console.error(error);
            return {
              ...entry,
              image: normalizeImageUrl(entry.image),
            };
          }
        }

        buildCard(entry) {
          const onSale = typeof entry.compareAtPrice === 'number' && entry.compareAtPrice > entry.price;
          const soldOut = entry.available === false;
          const discountPct = onSale
            ? Math.round(((entry.compareAtPrice - entry.price) / entry.compareAtPrice) * 100)
            : 0;

          const badge = soldOut
            ? '<span class="onlyfindz-home__soldout-badge">Ausverkauft</span>'
            : onSale
              ? `<span class="onlyfindz-home__deal-badge">-${discountPct}%</span>`
              : '';

          const li = document.createElement('li');
          li.className = 'marketplace-recently-viewed__item';
          li.innerHTML = `
            <article class="onlyfindz-home__product-card">
              <a href="${escapeHtml(entry.url)}" class="onlyfindz-home__product-media">
                ${badge}
                ${entry.image
                  ? `<img
                      src="${escapeHtml(entry.image)}"
                      alt="${escapeHtml(entry.imageAlt || entry.title)}"
                      class="onlyfindz-home__product-image"
                      loading="eager"
                      decoding="async"
                      width="533"
                      height="533"
                    >`
                  : `<div class="onlyfindz-image-placeholder onlyfindz-image-placeholder--card" role="img" aria-label="Produktfoto wird in Kürze ergänzt">
                      <span class="onlyfindz-image-placeholder__icon" aria-hidden="true">
                        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="4.5" y="9.5" width="39" height="29" rx="4" stroke="currentColor" stroke-width="2"/>
                          <circle cx="16.5" cy="19.5" r="3.25" stroke="currentColor" stroke-width="2"/>
                          <path d="M4.5 32L16 22.5L23.5 28.5L31.5 20.5L43.5 31.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </span>
                      <span class="onlyfindz-image-placeholder__copy">
                        <span class="onlyfindz-image-placeholder__title">Bild folgt in Kürze</span>
                        <span class="onlyfindz-image-placeholder__subtitle">Produktfoto wird ergänzt</span>
                      </span>
                    </div>`}
              </a>
              <wishlist-button
                class="wishlist-button"
                data-product-handle="${escapeHtml(entry.handle)}"
                data-product-title="${escapeHtml(entry.title)}"
                data-product-price="${typeof entry.price === 'number' ? this.formatMoney(entry.price) : ''}"
                data-product-image="${escapeHtml(entry.image || '')}"
                data-product-url="${escapeHtml(entry.url)}"
              >
                <button type="button" class="wishlist-button__trigger" aria-pressed="false" aria-label="${wishlistLabel}">
                  <span class="visually-hidden wishlist-button__label">${wishlistLabel}</span>
                  <span class="wishlist-button__icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" focusable="false">
                      <path d="M12 21.35 10.55 20C5.4 15.24 2 12.09 2 8.25 2 5.1 4.42 2.75 7.5 2.75c1.74 0 3.41.82 4.5 2.1 1.09-1.28 2.76-2.1 4.5-2.1 3.08 0 5.5 2.35 5.5 5.5 0 3.84-3.4 6.99-8.55 11.76L12 21.35Z"></path>
                    </svg>
                  </span>
                </button>
              </wishlist-button>
              <div class="onlyfindz-home__product-body">
                ${entry.vendor ? `<p class="onlyfindz-home__vendor">${escapeHtml(entry.vendor)}</p>` : ''}
                <h3 class="onlyfindz-home__product-title">
                  <a href="${escapeHtml(entry.url)}" class="onlyfindz-home__product-link">${escapeHtml(entry.title)}</a>
                </h3>
                <div class="onlyfindz-home__price-row">
                  ${this.buildPriceHtml(entry)}
                </div>
                ${this.buildActionsHtml(entry)}
              </div>
            </article>
          `;
          return li;
        }

        async render(currentHandle) {
          if (!recentlyViewedConsentGranted()) {
            this.content?.setAttribute('hidden', '');
            return;
          }

          const products = this.loadProducts()
            .filter((entry) => entry && entry.handle && entry.handle !== currentHandle)
            .slice(0, this.limit);

          if (!products.length || !this.list || !this.content) {
            this.content?.setAttribute('hidden', '');
            return;
          }

          const resolvedProducts = await Promise.all(products.map((entry) => this.resolveProductEntry(entry)));

          this.list.innerHTML = '';
          resolvedProducts.forEach((entry) => this.list.appendChild(this.buildCard(entry)));
          this.content.removeAttribute('hidden');
          this.list.dispatchEvent(new Event('scroll'));
        }
      }
    );
  }
})();
